export const APP_KEY = 'SweetPie';
